<template>
  <CRow>
    <CCol col="12" md="7">
        <CCard>
    <CCardHeader>
        <p> <img src="img/factory.svg" style="width:20px">Union</p>
        </CCardHeader>
           <CCardBody>
  <CDataTable
          :items="unionItem"
          :fields="fields"
          table-filter
          items-per-page-select
          :items-per-page="10"
          sorter
          pagination
          clickable-rows
          hover
          @row-clicked="rowClicked"
          caption="Breed"
        />
        </CCardBody>
        </CCard>
    </CCol>
    <CCol col="6" md="5">
      <CCard>
          <CCardHeader>
           <p>  <img src="img/factory.svg" style="width:20px">  Union Details</p>
           
          </CCardHeader>
          <CCardBody>
            <CForm>
                  
             <CInput
               
                label="UnionCode"
                horizontal
                autocomplete="name"
                name="unionCode"
                id="unionCode"
                required
                v-model="unionCode"
              />
                
                  
             <CInput
               
                label="UnionName"
                horizontal
                autocomplete="name"
                  name="unionName"
                id="unionName"
                required
                 v-model="unionName"
              />
                 <CInput
               
                label="Contact Person"
                horizontal
                autocomplete="name"
                name="ContactPerson"
                id="ContactPerson"
                required
                 v-model="ContactPerson"
              />
                 <CInput
               
                label="Email"
                horizontal
                autocomplete="name"
                 name="Email"
                id="Email"
                required
                 v-model="email"
              />
                 <CInput
               
                label="MobileNumber"
                horizontal
                autocomplete="name"
                 name="mobileNumber"
                id="mobileNumber"
                required
                 v-model="mobileNumber"
              />
                
               
 
             </CForm>

          </CCardBody>
           <CCardFooter>
                  <CButton color="info" style="width:100px" v-if="addButton" @click="addChilling">
                    <CIcon name="cilPencil" />&nbsp;Add
                  </CButton>&nbsp;
                  <CButton
                    color="success"
                    style="width:100px"
                    v-if="saveButton"
                    @click="updateChilling"
                  >
                    <CIcon name="cilCheck" />&nbsp;Save
                  </CButton>&nbsp;
                  <CButton
                    color="danger"
                    style="width:100px"
                    v-if="deleteButton"
                    @click="deleteChilling"
                  >
                    <CIcon name="cilXCircle" />&nbsp;Delete
                  </CButton>&nbsp;
<CButton color="success" style="width:100px" v-if="EditsaveButton" @click="addChilling">
            <CIcon name="cilCheck" />&nbsp;Save
          </CButton>&nbsp;


                  <CButton
                    color="secondary"
                    style="width:100px"
                    v-if="cancelButton"
                    @click="CancelChilling"
                  >
                    <CIcon name="cilWarning" />&nbsp;Cancel
                  </CButton> &nbsp;
                   <CButton
                    color="info"
                   
                    v-if="addnewButton"
                    @click="addChillingplus"
                  >
                    <CIcon name="cilPencil" />&nbsp;Add New
                  </CButton>
                </CCardFooter>
        </CCard>
    </CCol>
  </CRow>
</template>

<script>
import CTableWrapper from '../../tables/Table'
import { APIService } from "../../../apiservice.js";
import Swal from "sweetalert2";
export default {
     components: { CTableWrapper },
 
  data () {
    return{
      unionItem:[],
      editchilling:[],
      unionCode:null,
      unionName:"",
      mobileNumber:"",
      email:"",
      ContactPerson:"",
     addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton:true,
      cancelButton:false,
      EditsaveButton:false,
       fields: [
      {
        key: "unionCode",
        sortable: true
      },
      {
        key: "unionName",
        sortable: true
      },
       
         {
        key: "ContactPerson",
        sortable: true
      },
        {
        key: "email",
        sortable: true
      },
      {
        key: "mobileNumber",
        sortable: true
      },
    
      
    ],
   
    }
  },
  methods: {
   getunionList() {
      APIService.unionList().then(res => {
        if (res.status == 200) {
          this.unionItem= res.data;
           this.unionCode =   this.unionItem[0].unionCode;
      this.unionName =  this.unionItem[0].unionName;
      this.email =  this.unionItem[0].email;
        this.ContactPerson =  this.unionItem[0].ContactPerson;
      this.mobileNumber =  this.unionItem[0].mobileNumber;
        }
      });
    },
  
    rowClicked(item, index, column, e) {
      console.log("edit item", item, index, column, e);

      this.editchilling = item;
      this.unionCode = item.unionCode;
      this.unionName = item.unionName;
      this.email = item.email;
        this.ContactPerson = item.ContactPerson;
      this.mobileNumber = item.mobileNumber;
       this.addButton = false;
      this.saveButton = true;
      this.deleteButton = true;
      this.cancelButton =false;
      this.addnewButton=true;
     
    },
    addChilling() {
      let unionCode = this.unionCode;
      let unionName = this.unionName;
      let ContactPerson = this.ContactPerson;
        let email = this.email;
      let mobileNumber = this.mobileNumber;
      let data = {
      unionCode,
      unionName,
      ContactPerson,
      email,
      mobileNumber
      };
      APIService.saveUnion(data).then(res => {
        if (res.status == 200) {
          this.unionCode = null;
          this.unionName = "";
          this.ContactPerson = "";
          this.email="",
          this.mobileNumber=""
         this.getunionList();
            Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    addChillingplus(){
          this.unionCode = null;
          this.unionName = "";
          this.ContactPerson = "";
          this.email="",
          this.mobileNumber=""
        this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton =true;
          this.addnewButton=false;
           this.EditsaveButton=true     
          return getunionList();
         
    },
    
    CancelChilling(){
       this.unionCode = null;
          this.unionName = "";
          this.ContactPerson = "";
          this.email="",
          this.mobileNumber=""
        this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton =false;
          this.addnewButton=true;
           this.EditsaveButton=false,
         this.getunionList();
    },
    updateChilling() {
      let id = this.editchilling._id;
          let unionCode = this.unionCode;
      let unionName = this.unionName;
      let ContactPerson = this.ContactPerson;
        let email = this.email;
      let mobileNumber = this.mobileNumber;
          
      let value = {
          unionCode,
      unionName,
      ContactPerson,
      email,
      mobileNumber
      };
      let data = { id, value };
      APIService.unionUpdate(data).then(res => {
        if (res.status == 200) {
        this.unionCode = null;
          this.unionName = "";
          this.ContactPerson = "";
          this.email="",
          this.mobileNumber=""
            this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
           this.cancelButton =false;
           this.addnewButton=true;
        this.getunionList();
          Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },


 deleteChilling() {
//     Swal.fire({
//   title: 'Are you sure?',
//   text: "You won't be able to revert this!",
//   icon: 'warning',
//   showCancelButton: true,
//   confirmButtonColor: '#3085d6',
//   cancelButtonColor: '#d33',
//   confirmButtonText: 'Yes, delete it!'
// }).then((result) => {
//   if (result.value) {
//     Swal.fire(
//       'Deleted!',
//       'Your file has been deleted.',
//       'success'
//     )
//   }
//   this.delete();
// })

const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger'
  },
  buttonsStyling: false
})

swalWithBootstrapButtons.fire({
  title: 'Are you sure?',
  text: "You won't be able to revert this!",
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Yes, delete it!',
  cancelButtonText: 'No, cancel!',
  reverseButtons: true
}).then((result) => {
  if (result.value) {
    swalWithBootstrapButtons.fire(
      'Deleted!',
      'Your file has been deleted.',
      'success'
    )
     this.delete();
  } else if (
    /* Read more about handling dismissals below */
    result.dismiss === Swal.DismissReason.cancel
  ) {
    swalWithBootstrapButtons.fire(
      'Cancelled',
      'Your imaginary file is safe :)',
      'error'
    )
  }
})



  }, delete(){
      let id = this.editchilling._id;
      let data = { id };
      APIService.unionDelete(data).then(res => {
        if (res.status == 200) {
         this.unionCode = null;
          this.unionName = "";
          this.ContactPerson = "";
          this.email="",
          this.mobileNumber=""
             this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
           this.cancelButton =false;
             this.addnewButton=true;
              this.EditsaveButton=false,
          this.getunionList();
        }
      });


      
    }
  },
  created() {
    // this.getBreedList();
    this.getunionList();
  }
  
}
</script>
